import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { HomepageService } from '../../services/homepage.service';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';
import { BehaviorSubject } from 'rxjs';
import { IMarketingProductContainer } from '../../models/marketing-products-container';
import { isNullOrUndefined } from 'core-max-lib';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { Router } from '@angular/router';
import { ILoanParams } from '../../../../shared/cardholders-core/models/loan-params';
import { ModuleTransferService } from '../../../../shared/cardholders-core/services/module-transfer.service';
import { BaseProductsComponent } from '../base-components/base-products.component';

@Component({
    selector: 'app-products',
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductsComponent extends BaseProductsComponent implements OnInit, AfterViewInit {
    marketingProducts: any;
    desktopBackgroungImage: any;
    mobileBackgroungImage: any;
    loanLegalText: any;
    itemsPerGroup = 3;
    groups = [];
    productsSlideConfig = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        centerMode: true,
        // variableWidth: true,  /*remove for fade*/
        // variableHeight: true, /*remove for fade*/
        speed: 200,
        swipeSpeed: 300,
        arrows: true,
        fade: true /*add fade true for fade*/,
        rtl: true,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    arrows: false,
                    centerMode: true,
                    slidesToShow: 2,
                    variableWidth: true,
                    variableHeight: true,
                    fade: false,
                    slidesToScroll: 1
                }
            }
        ]
    };
    showSlick = false;
    isLoaded: BehaviorSubject<boolean>;

    constructor(
        private homepageService: HomepageService,
        public uiHelper: UiHelperService,
        // private calcService: CalcService,
        private gtmService: GtmService,
        private router: Router,
        private transferSvc: ModuleTransferService
    ) {
        super();
    }

    ngOnInit(): void {
        this.isLoaded = new BehaviorSubject<boolean>(false);
        this.homepageService.loadMarketingProducts().then((res: IMarketingProductContainer) => {
            this.marketingProducts = this.getMarketingProducts(res.MarketingProducts);
            this.desktopBackgroungImage = res.DesktopBackgroundImage;
            this.mobileBackgroungImage = res.MobileBackgroundImage;
            this.loanLegalText = res.LoanLegalText;
            this.groups = Array.from(Array(Math.ceil(this.marketingProducts.length / this.itemsPerGroup)).keys());
        });

        if (this.uiHelper.isBrowser) {
            this.showSlick = true;
        }
    }

    getMarketingProducts(marketingProductsFromUmbraco: any[]) {
        if (!this.uiHelper.isMobileRequest) {
            return marketingProductsFromUmbraco;
        }
        marketingProductsFromUmbraco.forEach(product => {
            product.Asterisk = product.AsteriskForMobile;
            product.BackgroundColor = product.BackgroundColorForMobile;
            product.BackgroundColorOpacity = product.BackgroundColorOpacityForMobile;
            product.BackgroundType = product.BackgroundTypeForMobile;
            product.IsLoan = product.IsLoanForMobile;
            product.IsOpenLinkInNewTab = product.IsOpenLinkInNewTabForMobile;
            product.ProductBgImage = product.ProductBgImageForMobile;
            product.ProductButtonLink = product.ProductButtonLinkForMobile;
            product.ProductButtonText = product.ProductButtonTextForMobile;
            product.ProductSubTitle = product.ProductSubTitleForMobile;
            product.ProductTitle = product.ProductTitleForMobile;
        });
        return marketingProductsFromUmbraco;
    }

    ngAfterViewInit(): void {
        if (this.uiHelper.isBrowser) {
            this.updateLoadStatus(true);
            setTimeout(() => {
                if (this.uiHelper.detectIE()) {
                    const resizeEvent = window.document.createEvent('UIEvents');
                    resizeEvent.initEvent('resize', true, false);
                    window.dispatchEvent(resizeEvent);
                } else {
                    window.dispatchEvent(new Event('resize'));
                }
            }, 250);
        }
    }

    updateLoadStatus(loadStatus: boolean): void {
        this.isLoaded.next(loadStatus);
    }

    getBackgroundImage() {
        if (this.uiHelper.IsMobile()) {
            return isNullOrUndefined(this.mobileBackgroungImage) ? '' : this.mobileBackgroungImage.Url;
        } else {
            return isNullOrUndefined(this.desktopBackgroungImage) ? '' : this.desktopBackgroungImage.Url;
        }
    }

    registrationToGtm(event) {
        try {
            event.slick.$nextArrow[0].onclick = () => {
                this.gtmService.pushDirective({
                    category: 'New website - anonymous',
                    action: 'Click on product arrow',
                    label: 'Right'
                });
            };
            event.slick.$prevArrow[0].onclick = () => {
                this.gtmService.pushDirective({
                    category: 'New website - anonymous',
                    action: 'Click on product arrow',
                    label: 'Left'
                });
            };
        } catch (error) {}
    }

    swipeToGtm(event) {
        event.currentSlide < event.nextSlide
            ? event.currentSlide === 0 && event.nextSlide === event.slick.slideCount - 1
                ? this.swipePush('Right')
                : this.swipePush('Left')
            : event.currentSlide === event.slick.slideCount - 1 && event.nextSlide === 0
                ? this.swipePush('Left')
                : this.swipePush('Right');
    }

    swipePush(direction: string) {
        this.gtmService.pushDirective({
            category: 'New website - anonymous',
            action: 'Swipe products',
            label: direction
        });
    }

    pushToGtm(product: any) {
        if (product.IsLoan) {
            this.gtmService.pushDirective({
                category: 'New website - anonymous',
                action: 'Click on loans cube',
                label: `amount: ${this.getCodeByAmount(this.loan.amount)}`
            });
            this.gtmService.pushDirective({
                category: 'New website - anonymous',
                action: 'Click on loans cube',
                label: `payments: ${this.loan.payments}`
            });
            this.gtmService.pushDirective({
                category: 'New website - anonymous',
                action: 'Click on product',
                label: 'כשצריך הלוואה מיידית'
            });
        } else {
            this.gtmService.pushDirective({
                category: 'New website - anonymous',
                action: 'Click on product',
                label: product.ProductTitle
            });
        }
    }

    getCodeByAmount(amount: string): string {
        let result = '';
        for (let i = 0; i < amount.length; i++) {
            if (/^\d+$/.test(amount[i])) {
                result += amount[i];
            }
        }
        const x = Number(result);
        if (x < 5000) {
            return 'A';
        }
        if (x < 10000) {
            return 'B';
        }
        if (x < 15000) {
            return 'C';
        }
        if (x < 20000) {
            return 'D';
        }
        if (x < 30000) {
            return 'E';
        }
        if (x < 40000) {
            return 'F';
        }
        if (x < 50000) {
            return 'G';
        }
        return 'H';
    }

    getProductLink(product: any) {
        return product.ProductButtonLink;
    }

    getProductLinkRoles(product: any) {
        return product.ButtonLinkRoles;
    }

    onProductButtonClick(product: any) {
        this.pushToGtm(product);
        if (product.IsLoan) {
            const loanParams: ILoanParams = {
                amount: this.getLoanAmountFromString(this.loan.amount),
                payments: Number(this.loan.payments)
            };
            this.transferSvc.setData('homepageLoanParams', loanParams);
            this.router.navigateByUrl(`/loans/calc?RefId=bath&sourceGA=MarketingProducts&amount=${loanParams.amount}&payments=${loanParams.payments}`);
            return;
        }
        location.href = product.ProductButtonLink;
    }

    private getLoanAmountFromString(amount: string): number {
        let result = '';
        for (let i = 0; i < amount.length; i++) {
            if (/^\d+$/.test(amount[i])) {
                result += amount[i];
            }
        }
        return Number(result);
    }
}
